import Document from "./Document";
import Faults from "./Faults";
import Confirm from "./Confirm";

export default {
  DOCUMENT: Document,
  FAULTS: Faults,
  CONFIRM: Confirm,
};
